import { BalanceRecord, TManaActionName, TManaActionParam } from "@pro/common/contracts/tribalbooks/mana_types";
import { TransactResult } from "eosjs/dist/eosjs-api-interfaces";
import { Authorization } from "eosjs/dist/eosjs-serialize";
import { EosApi, EosAsset, EosUtils } from "../../eos";

export class ManaContract
{
	private readonly _api: EosApi;
	private readonly _account: string;

	constructor(api: EosApi, account: string)
	{
		this._account = account;
		this._api = api;
	}

	action<N extends TManaActionName>(name: N,
	                              auth: Authorization | Authorization[],
	                              data: TManaActionParam<N>, {broadcast = true} = {}): Promise<TransactResult>
	{
		return this._api.transact([{
			name: name,
			account: this._account,
			authorization: EosUtils.castAuth(auth),
			data: data,
		}], {broadcast});
	}

	get api()
	{
		return this._api;
	}

	async getBalance(account: string): Promise<EosAsset>
	{
		let table = await this._api.getTable<BalanceRecord>({
			code: this._account,
			scope: account,
			table: "accounts",
			key_type: "i64",
			limit: 1,
		});

		return EosAsset.parse(table.rows.length ? table.rows[0].balance : "0 MANA");
	}
}
